import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  column-gap: 5px;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--color-greyEC);
  border-radius: var(--border-radius8);
  padding: 0 5px 0 10px;
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  font-size: var(--font-size18);
  padding: 5px 0;
`;

export const Text = styled.p`
  font-size: var(--font-size18);
  text-align: left;
  color: var(--color-grey6A);
`;

export const Box = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 0 6px;
  margin-top: 8px;
`;

export const Label = styled.p`
  height: 25px;
  border-radius: var(--border-radius8);
  background-color: var(--color-green65);
  font-size: var(--font-size13);
  font-weight: var(--font-weight500);
  letter-spacing: 0.9px;
  line-height: 24px;
  text-transform: uppercase;
  color: #005e18;
  box-shadow: var(--shadow-focus);
  padding: 0 8px;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  min-width: 25px;
  height: 34px;
  border-radius: var(--border-radius8);
  outline: none;
  border: none;
  cursor: pointer;
  background: none;
  color: var(--color-grey97);
  @media (hover) {
    &:hover {
      background: none;
      color: var(--color-black);
    }
  }
`;
